import { render, staticRenderFns } from "./CvQA.vue?vue&type=template&id=4a07e816&scoped=true&"
import script from "./CvQA.vue?vue&type=script&lang=js&"
export * from "./CvQA.vue?vue&type=script&lang=js&"
import style0 from "./CvQA.vue?vue&type=style&index=0&id=4a07e816&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a07e816",
  null
  
)

export default component.exports